import { useRef, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useQueryClient } from "@tanstack/react-query";
import { api, ApiError } from "../lib/api";

// O magic token é one-time. Consumir no carregamento da página entrega o token
// a qualquer scanner de link que execute o JS do SPA — foi o que aconteceu com
// o provedor de email de rogatis.io. O token só é consumido no clique.
const AuthVerify = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const qc = useQueryClient();
  const token = searchParams.get("token");
  const returnTo = searchParams.get("returnTo") ?? "/";
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState<string | null>(token ? null : "Token ausente na URL");
  const inFlight = useRef(false);

  const handleSubmit = async () => {
    if (!token || inFlight.current) return;
    inFlight.current = true;
    setSubmitting(true);
    setError(null);
    try {
      await api.auth.verify(token);
      await qc.invalidateQueries({ queryKey: ["session"] });
      navigate(returnTo, { replace: true });
    } catch (err) {
      const msg =
        err instanceof ApiError
          ? typeof err.payload === "object" && err.payload && "error" in err.payload
            ? String((err.payload as { error: unknown }).error)
            : `Erro ${err.status}`
          : (err as Error).message;
      setError(msg);
      setSubmitting(false);
      inFlight.current = false;
    }
  };

  if (error) {
    return (
      <div data-testid="auth-verify" className="max-w-sm mx-auto mt-16 text-center">
        <h1 className="text-xl font-semibold mb-3">Não consegui entrar</h1>
        <p data-testid="auth-verify-error" className="text-sm text-slate-600 mb-6">
          {error}
        </p>
        <button
          onClick={() => navigate("/login", { replace: true })}
          className="rounded-lg border border-slate-300 px-4 py-2 text-sm hover:bg-slate-50"
        >
          Pedir novo link
        </button>
      </div>
    );
  }

  return (
    <div data-testid="auth-verify" className="max-w-sm mx-auto mt-16 text-center">
      <h1 className="text-xl font-semibold mb-3">Confirme seu acesso</h1>
      <p className="text-sm text-slate-600 mb-6">
        Clique abaixo para entrar no jp-voice.
      </p>
      <button
        data-testid="auth-verify-submit"
        onClick={handleSubmit}
        disabled={submitting}
        className="rounded-lg bg-slate-900 text-white px-5 py-2.5 text-sm hover:bg-slate-800 disabled:opacity-60"
      >
        {submitting ? "Entrando..." : "Entrar"}
      </button>
    </div>
  );
};

export default AuthVerify;
